var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBigFatBlackPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M76.875 36.875H43.125V3.125C43.125 1.39906 41.7259 0 40 0C38.2741 0 36.875 1.39906 36.875 3.125V36.875H3.125C1.39906 36.875 0 38.2741 0 40C0 41.7259 1.39906 43.125 3.125 43.125H36.875V76.875C36.875 78.6009 38.2741 80 40 80C41.7259 80 43.125 78.6009 43.125 76.875V43.125H76.875C78.6009 43.125 80 41.7259 80 40C80 38.2741 78.6009 36.875 76.875 36.875Z",
    fill: "#353941"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBigFatBlackPlus);
export default __webpack_public_path__ + "static/media/icon-big-fat-black-plus.071b60f9f5e7eb5661112287e2065a97.svg";
export { ForwardRef as ReactComponent };